import React from "react";
import InputFactory from "../InputFactory";
import FormTab from "./FormTab";
import checkCondition from "../../checkCondition";
import toDisplayCase from "../../toDisplayCase";

function group(schema) {
  const { fields, sections } = schema;
  const groups = {
    General: {},
  };
  for (const key in fields) {
    const options = fields[key];
    if (sections && sections[options.section]) {
      groups[options.section] = groups[options.section] || {};
      groups[options.section][key] = options;
    } else {
      groups["General"][key] = options;
    }
  }
  return groups;
}

const defaultProps = {
  excludeFields: [],
  hasLabel: true,
};

function FormFactory({
  className,
  schema,
  object,
  onChange,
  excludeFields,
  hasLabel,
  roles,
  ...props
}) {
  const tabs = schema.tabs;
  const initialTab =
    tabs && Object.keys(tabs).length > 0 ? Object.keys(tabs)[0] : null; // Set the initial tab value
  const [_tab, setTab] = React.useState(initialTab);
  const sections = schema.sections || {};
  const groups = group(schema);
  return (
    <>
      <FormTab roles={roles} onSet={setTab} tabs={tabs} object={object} />
      {Object.keys(groups).map((key, index) => {
        const fields = groups[key];
        const {
          label,
          icon = "bi bi-file-text",
          description,
        } = sections[key] || {};
        const components = Object.keys(fields)
          .map((field) => {
            if (excludeFields.includes(field)) return null;
            const conditions =
              fields[field].if || fields[field].or || fields[field].and;
            if (conditions && !checkCondition(fields[field], object)) {
              return null;
            }
            let {
              type,
              pattern,
              write,
              tab,
              col,
              _write,
              _io,
              _required,
              required,
              ...options
            } = fields[field];
            if (_tab && tab && _tab !== tab) return null;
            if (write === false || _io === false || _write === false)
              return null;
            if (field === "password") {
              type = "Password";
            }
            const __required = props.required ?? _required ?? required;
            return (
              <div className={col || className} key={field}>
                {type !== "Boolean" && hasLabel && (
                  <label className="form-label fs-sm fw-bold text-muted">
                    {options.label || toDisplayCase(field)}{" "}
                    {__required && <span className="text-danger">*</span>}
                  </label>
                )}
                {props.componentFactory ? (
                  React.createElement(props.componentFactory, {
                    key: field,
                    object: object,
                    field: field,
                    onChange: onChange,
                    type: type,
                    required: __required,
                    ...options,
                    ...props,
                  })
                ) : (
                  <InputFactory
                    key={field}
                    object={object}
                    field={field}
                    onChange={onChange}
                    type={type}
                    required={__required}
                    {...options}
                    {...props}
                  />
                )}
              </div>
            );
          })
          .filter((c) => c);
        return (
          <>
            {components.length > 0 && Object.keys(sections).length > 0 && (
              <div
                className={`col-12 rounded-1 d-flex border-bottom align-items-center pb-1 gap-2 ${index !== 0 || (index !== 1 && "mt-4")} ${index}`}
              >
                <div className="p-1 rounded-1 bg-light border border-1 px-2">
                  <i className={`${icon} text-primary fw-bold`}></i>
                </div>
                <div className="d-flex flex-column gap-0">
                  <p className="small fw-bold mb-0 text-primary">
                    {label || key}
                  </p>
                  <p className="small mb-0 text-muted">{description}</p>
                </div>

                <hr />
              </div>
            )}
            <div className="row">{components}</div>
          </>
        );
      })}
    </>
  );
}

FormFactory.defaultProps = defaultProps;
export default FormFactory;
